const stepsData = [
  {
    step: "Step 1",
    title: "Register your interest to begin the application process",
    description: "Register your interest to begin the application process",
  },
  {
    step: "Step 2",
    title: "Our team will get in touch and guide you on next steps",
    description: "Our team will get in touch and guide you on next steps",
  },
  {
    step: "Step 3",
    title: "Carz Bazzar conducts a quick verification to confirm eligibility",
    description: "Carz Bazzar conducts a quick verification to confirm eligibility",
  },
  {
    step: "Step 4",
    title: "Align with Carz Bazzar standards, launch franchise, start operations",
    description: "Align with Carz Bazzar standards, launch franchise, start operations",
  },
];

const JourneySteps = () => {
  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Journey to become a franchise owner
          </h2>
          <div className="w-24 h-1 bg-[#ff3131] mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stepsData.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection line for desktop */}
              {index < stepsData.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gray-200 z-0"></div>
              )}
              
              <div className="relative z-10 bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-shadow duration-300">
                {/* Step number circle */}
                <div className="flex justify-center mb-4">
                  <div className="w-12 h-12 bg-[#ff3131] text-white rounded-full flex items-center justify-center font-bold text-lg">
                    {index + 1}
                  </div>
                </div>
                
                {/* Step content */}
                <div className="text-center">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    {step.step}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {step.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Mobile connection lines */}
        <div className="lg:hidden mt-8 flex justify-center">
          <div className="flex space-x-2">
            {stepsData.map((_, index) => (
              <div key={index} className="flex items-center">
                <div className="w-2 h-2 bg-[#ff3131] rounded-full"></div>
                {index < stepsData.length - 1 && (
                  <div className="w-8 h-0.5 bg-gray-300 mx-2"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySteps;
